function normaliseData(dataToNormalise) {
  const {
    name,
    address,
    requirements,
    summary,
    description,
    motivations,
    additionalInformation,
    commitment,
  } = dataToNormalise;

  const result = [
    { id: 'name', data: name },
    { id: 'city', data: address.city },
    {
      id: 'trainingRequired',
      data: requirements.pvg_level !== 'Not Required' || requirements.dbs_level !== 'Not Required',
    },
    {
      id: 'description',
      data: {
        summary,
        body: description,
        motivations,
        additionalInformation,
      },
    },
  ];

  if (requirements.age || requirements.driving_license) {
    result.push({
      id: 'requirements',
      data: ['age', 'driving_license']
        .filter((key) => requirements[key])
        .reduce((accum, key) => {
          if (key === 'age') {
            return [...accum, `Age ${requirements.age}`];
          }

          if (key === 'driving_license' && requirements[key] === 'Yes') {
            return [...accum, 'Driving licence'];
          }

          return accum;
        }, []),
    });
  }

  if (Object.values(commitment).some((value) => value)) {
    result.push({
      id: 'commitment',
      data: Object.keys(commitment)
        .filter((key) => commitment[key])
        .map((key) => ({
          id: key,
          value: commitment[key],
        })),
    });
  }

  return result;
}

export default normaliseData;
